
import { defineComponent } from 'vue';
import {
  ActivityIndicator,
  AjaxHelper,
} from 'CoreHome';

export default defineComponent({
  components: {
    ActivityIndicator,
  },
  data() {
    return {
      groupName: '',
      isCreatingGroup: false,
    };
  },
  emits: ['group-created'],
  methods: {
    createGroup(groupName: string) {
      this.isCreatingGroup = true;

      AjaxHelper.post({
        module: 'API',
        format: 'json',
        method: 'GroupPermissions.createGroup',
      }, {
        groupName,
      },
      {
        errorElement: '#ajaxErrorCreateGroup',
      }).then((response) => {
        this.$emit('group-created', response);
      }).finally(() => {
        this.isCreatingGroup = false;
      });
    },
  },
});
